import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { ResponseWithPagination } from 'constants/types'
import { TGetVendorListRequest } from '../VendorsList/types'
import { TMyVendors } from './types'

const fetcher = new Fetcher({})

export const getMyVendorsRequest = async (data) =>
  fetcher.request<TGetVendorListRequest, ResponseWithPagination<TMyVendors>>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.VENDORS}${API_DICTIONARY.MY_VENDORS}`,
    method: HTTP_METHODS.GET,
    ...data
  })
